import { Flex, Modal } from '@aloft/toolkit-sui';

import { useZodForm } from '../../../hooks/useZodForm.ts';
import { submitCostMultiplierForm } from '../../../redux/features/orderSlice.ts';
import { selectCostMultiplierFormData } from '../../../redux/features/selectors/orderSelectors.ts';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.ts';
import { CustomMultiplier } from './CustomMultiplier.tsx';
import { ZipCodeMultiplier } from './ZipCodeMultiplier.tsx';
import { schCostMultiplier } from './schCostMultiplier.ts';

type Props = {
  onClose: () => void;
};

export const CostMultiplierModal = ({ onClose }: Props) => {
  const dispatch = useAppDispatch();
  const defaultFormValues = useAppSelector(selectCostMultiplierFormData);
  const {
    control,
    formState: { errors, isValid },
    handleSubmit,
  } = useZodForm({
    defaultValues: defaultFormValues,
    schema: schCostMultiplier,
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  return (
    <Modal
      title="Cost Multiplier"
      size="3xl"
      isOpen
      onClose={onClose}
      showCloseButton={false}
      primaryAction={{
        id: 'cost-multiplier-save-button',
        text: 'Save',
        onClick: handleSubmit(
          (data) => {
            dispatch(submitCostMultiplierForm({ costMultiplier: data.costMultiplier }));
            onClose();
          },
          (errors) => {
            console.error('Error submitting cost multiplier', errors);
          },
        ),
        disabled: !isValid,
      }}
      secondaryAction={{
        id: 'cost-multiplier-cancel-button',
        text: 'Cancel',
        onClick: () => onClose(),
      }}
    >
      <Flex flexDirection="column" gap="1.5rem">
        <ZipCodeMultiplier />
        <CustomMultiplier control={control} errors={errors} />
      </Flex>
    </Modal>
  );
};
